import React, { Component } from "react";
import { PublicClientApplication, EventType } from "@azure/msal-browser";
import getadb2cauth from "./getadb2cauth";
import registerServiceWorker from "./registerServiceWorker";
import { Loading } from "./components/Loading/Loading";

export const AuthContext = React.createContext();

let auth_redirectUri = "";
class AuthProvider extends Component {
  state = {
    msalInstance: null,
    isLoggedIn: false,
    idToken: "",
    scopes: [],
    redirectUri: "",
  };

  componentDidMount() {
    getadb2cauth()
      .then((config) => {
        auth_redirectUri = config.redirectUri;

        const msalInstance = new PublicClientApplication({
          auth: {
            clientId: config.applicationId,
            authority: `${config.instance}/${config.tenant}/${config.signInPolicy}`,
            knownAuthorities: [`${config.instance}`],
            redirectUri: config.redirectUri,
          },
          cache: {
            storeAuthStateInCookie: true,
          },
        });

        this.setState({ msalInstance, scopes: config.scopes, redirectUri: config.redirectUri });

        msalInstance
          .handleRedirectPromise()
          .then((response) => {
            if (response) {
              console.log("Login response received:", response);
              this.handleResponse(response);
            } else {
              console.log("No login response. Handling authentication...");
              this.handleAuthentication();
            }
          })
          .catch((error) => {
            console.error("Error handling redirect promise: ", error);
            if (error.message.includes("AADB2C90118")) {
              this.redirectToPasswordReset(config);
            } else if (error.message.includes("AADB2C90151")) {
              window.location.replace("/Response/AADB2C90151");
            } else if (error.message.includes("AADB2C90157")) {
              window.location.replace("/Response/AADB2C90157");
            }
          });

        msalInstance.enableAccountStorageEvents();

        msalInstance.addEventCallback((event) => {
          if (
            event.eventType === EventType.LOGIN_SUCCESS ||
            event.eventType === EventType.ACQUIRE_TOKEN_SUCCESS ||
            event.eventType === EventType.SSO_SILENT_SUCCESS
          ) {
            const account = event.payload.account;
            msalInstance.setActiveAccount(account);
          }
        });
      })
      .catch((error) => {
        console.error("Error loading AD B2C config:", error);
      });
  }

  componentDidUpdate(prevProps, prevState) {
    if (!prevState.isLoggedIn && this.state.isLoggedIn) {
      registerServiceWorker();
    }
  }

  isTokenExpired = (token) => {
    if (!token) return true;

    try {
      const payload = JSON.parse(atob(token.split(".")[1]));
      const exp = payload.exp * 1000;
      return Date.now() > exp;
    } catch (error) {
      console.error("Error decoding token:", error);
      return true;
    }
  };

  clearCache = () => {
    console.log("Limpando cache e redirecionando para logout...");
    const { msalInstance } = this.state;
    msalInstance.logout();
  };

  handleResponse = (response) => {
    const account = response.account;
    const idToken = response.idToken;

    if (this.isTokenExpired(idToken)) {
      console.log("Token expirado. Limpando cache e redirecionando para login...");
      this.clearCache();
      this.performLoginRedirect();
      return;
    }

    this.setState({
      isLoggedIn: true,
      idToken,
    });

    this.state.msalInstance.setActiveAccount(account);
  };

  performLoginRedirect = () => {
    console.log("Redirecionando para login...");
    const { msalInstance, scopes, redirectUri } = this.state;
    const loginRequest = { scopes, redirectUri: auth_redirectUri };
    msalInstance.loginRedirect(loginRequest);
  };

  handleAuthentication = async () => {
    const { msalInstance, scopes } = this.state;
    const loginRequest = { scopes };

    try {
      const accessTokenResponse = await msalInstance.acquireTokenSilent(loginRequest);

      if (this.isTokenExpired(accessTokenResponse.idToken)) {
        console.log("Token expirado. Redirecionando para login...");
        this.performLoginRedirect();
        return;
      }

      this.setState({
        isLoggedIn: true,
        idToken: accessTokenResponse.idToken,
      });
    } catch (error) {
      console.error("Error acquiring token silently: ", error);
      this.performLoginRedirect();
    }
  };

  redirectToPasswordReset = (config) => {
    console.log("Redirecionando para redefinição de senha...");
    const { msalInstance } = this.state;
    msalInstance.loginRedirect({
      authority: `${config.instance}/${config.tenant}/B2C_1A_PasswordReset`,
      redirectUri: config.redirectUri,
    });
  };

  render() {
    const { children } = this.props;
    const { msalInstance, isLoggedIn, idToken } = this.state;

      if (!msalInstance) {
          return <div>  </div>; // Indicador de carregamento
    }

    return (
      <AuthContext.Provider
        value={{
          msalInstance,
          isLoggedIn,
          idToken,
          performLoginRedirect: this.performLoginRedirect,
        }}>
        {isLoggedIn && children}
      </AuthContext.Provider>
    );
  }
}

export default AuthProvider;
